module.exports = __webpack_public_path__ + "e21a79f9b7745a7b3266093bd1f20b01.webp";